import React from 'react';
import classnames from 'classnames';
import { InputMessage } from '../input-message';
import { Text } from '../text';
import styles from './fieldset.module.scss';

export type FieldsetProps = {
  legend?: string;
  subline?: string;
  message?: { text: string; id: string };
  isInvalid?: boolean;
} & Pick<React.FieldsetHTMLAttributes<HTMLFieldSetElement>, 'className' | 'children' | 'disabled'>;

const baseClass = 'fieldset';

export const Fieldset: React.FC<FieldsetProps> = ({
  legend,
  children,
  className,
  disabled = false,
  message,
  isInvalid,
  subline
}) => {
  const classes = classnames(styles[baseClass], { [styles[`${baseClass}--is-invalid`]]: isInvalid }, className);

  return (
    <fieldset className={classes} disabled={disabled} data-testid="fieldset-component" aria-describedby={message?.id}>
      {legend && (
        <>
          <legend className={styles[`${baseClass}__legend`]}>{legend}</legend>
          {subline && <Text className={styles[`${baseClass}__subline`]}>{subline}</Text>}
        </>
      )}
      <div className={styles[`${baseClass}__inputs`]}>{children}</div>
      {message && (
        <InputMessage
          message={message.text}
          isError={Boolean(isInvalid)}
          disabled={disabled}
          id={message.id}
          className={styles[`${baseClass}__message`]}
        />
      )}
    </fieldset>
  );
};
